import React, { useCallback, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";
import { generatePath } from "react-router";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import NavRoutes from "core/app/util/NavRoutes";
import useSmartLinkHistory from "core/shared/hooks/useSmartLinkHistory";
import ReportsMessages from "reports/intl/ReportsMessages";
import PrimeReactConstants from "core/app/util/PrimeReactConstants";

const {
  MESSAGE_SEVERITY: { INFO },
} = PrimeReactConstants;

const btnStyle = { padding: 0, textAlign: "left", overflowWrap: "anywhere" };

const StLabel = styled.span`
  font-weight: normal;
`;

const ReportName = ({ id, reportName }) => {
  const toastRef = useRef(null);
  const { pop } = useSmartLinkHistory();
  const { formatMessage } = useIntl();

  const btnLabel = useMemo(() => {
    return (
      <StLabel title={formatMessage(ReportsMessages.edit)}>
        {reportName}
      </StLabel>
    );
  }, [formatMessage, reportName]);

  const handleClick = useCallback(
    (evt) => {
      evt.stopPropagation(); // prevent row selection

      toastRef.current.show({
        detail: "Coming soon!",
        severity: INFO,
        summary: "Info",
      });

      return;
      // eslint-disable-next-line no-unreachable
      pop(generatePath(NavRoutes.reports.dataExportEdit, { id }));
    },
    [id, pop]
  );

  return (
    <>
      <Toast ref={toastRef} />
      <Button label={btnLabel} link onClick={handleClick} style={btnStyle} />
    </>
  );
};

ReportName.propTypes = {
  id: PropTypes.string,
  reportName: PropTypes.string,
};

export default ReportName;
